import { render, staticRenderFns } from "./ProgramGroupGrid.vue?vue&type=template&id=3e2bce0e&scoped=true"
import script from "./ProgramGroupGrid.vue?vue&type=script&lang=js"
export * from "./ProgramGroupGrid.vue?vue&type=script&lang=js"
import style0 from "./ProgramGroupGrid.vue?vue&type=style&index=0&id=3e2bce0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2bce0e",
  null
  
)

export default component.exports